import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { StandardPolicyGuard } from 'src/auth/guard';
// layouts
import AppLayout from 'src/layouts/app';
// components
import { LoadingScreen } from 'src/components/loading-screen';

const PurchaseOrdersPage = lazy(() => import('src/pages/purchaseOrders/purchaseOrders'));
const CreatePurchaseOrderPage = lazy(() => import('src/pages/purchaseOrders/createPurchaseOrder'));
const EditPurchaseOrderPage = lazy(() => import('src/pages/purchaseOrders/editPurchaseOrder'));
const DetailsPurchaseOrderPage = lazy(
  () => import('src/pages/purchaseOrders/detailsPurchaseOrder')
);

export const purchaseOrdersRoutes = [
  {
    path: 'purchase-orders',
    element: (
      <StandardPolicyGuard
        fallback={
          <AppLayout>
            <LoadingScreen />
          </AppLayout>
        }
      >
        <AppLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </AppLayout>
      </StandardPolicyGuard>
    ),
    children: [
      { path: '', element: <PurchaseOrdersPage />, index: true },
      { path: 'new', element: <CreatePurchaseOrderPage /> },
      { path: 'edit/:id', element: <EditPurchaseOrderPage /> },
      { path: 'details/:id', element: <DetailsPurchaseOrderPage /> },
    ],
  },
];
